var _excluded = ["children"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, Suspense, useEffect } from 'react';
import { shape, string } from 'prop-types';
import { mergeClasses } from '../../classify';
import defaultClasses from './header.css';
import StokesLogoFr from '@magento/venia-ui/venia-static/icons/STOKES_FR.svg';
import StokesLogoEn from '@magento/venia-ui/venia-static/icons/STOKES_EN.svg';
import ThinkKitchen from '@magento/venia-ui/venia-static/icons/thinkkitchen.svg';
import HeaderMenu, { getSeoAttributeTitle } from "./headerMenu";
import { useScrollLock } from '@magento/peregrine';
import AccountCartHeader from './accountCartHeader';
import parse_html from '@magento/pagebuilder/lib/helper';
import Upperheader from './upperHeader';
import { useIntl } from 'react-intl';
import { resourceUrl } from "../../drivers";
import BBLink from "../BBLink";
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import Autocomplete from "../Category/autocomplete";
import { useAppContext } from "@magento/peregrine/lib/context/app";
import useClickOutside from "@magento/peregrine/lib/hooks/useClickOutside";
var SearchBar = React.lazy(() => import('../SearchBar'));
export var Div = _ref => {
  var {
      children
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", restProps, children);
};
var Header = props => {
  var {
    setShowNav,
    showNav,
    navbar,
    getFormattedHeaderData
  } = props;
  var [, {
    closeAutocomplete
  }] = useAppContext();
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var {
    outWrapperRef,
    outWrapperRef2
  } = useClickOutside({
    actionOnClickOutside: closeAutocomplete
  });
  var logo = currentStoreCode === 'en' ? StokesLogoEn : StokesLogoFr;
  var {
    formatMessage
  } = useIntl();
  var classes = mergeClasses(defaultClasses, props.classes);
  var menuHeaderData = getFormattedHeaderData();
  var [accountMenu, setAccountMenu] = useState('init');
  var [menuHeadersPosition, setMenuHeadersPosition] = useState([]);
  useEffect(() => {
    document.querySelector('main').setAttribute('data-navbar', navbar ? 'navbar' : '');
  }, [navbar]);
  var STATIC_STRINGS = {
    loading: 'loading',
    signIn: 'Sign In',
    cart: 'Cart',
    seperator: formatMessage({
      id: 'seperator',
      defaultMessage: 'Seperator'
    })
  };
  var activeMenuHeader = showNav !== "" && menuHeaderData && menuHeaderData.find(el => el.name === showNav);
  var activeMenu = activeMenuHeader && !!(activeMenuHeader.left && activeMenuHeader.left.length || activeMenuHeader.right && activeMenuHeader.right.length);
  useScrollLock(!!activeMenu);
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, STATIC_STRINGS.loading)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    style: activeMenu ? {
      boxShadow: '0 0 100vh 100vh rgba(0, 0, 0, 0.5)'
    } : {}
  }, navbar && /*#__PURE__*/React.createElement(Upperheader, {
    headerType: 'headerV1'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.middleHeader
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: '/',
    style: {
      justifySelf: 'left'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: ThinkKitchen,
    alt: 'think-kitchen',
    style: {
      height: '100%',
      width: '6.25rem',
      pointerEvents: 'none',
      display: 'block'
    }
  }), /*#__PURE__*/React.createElement("img", {
    className: classes.middleLogo,
    src: logo,
    alt: 'Stokes'
  })), /*#__PURE__*/React.createElement(SearchBar, {
    outWrapperRef: outWrapperRef,
    navbar: navbar,
    styles: {
      justifySelf: 'center'
    }
  }), /*#__PURE__*/React.createElement(AccountCartHeader, {
    styles: {
      justifySelf: 'right'
    },
    setAccountMenu: setAccountMenu,
    accountMenu: accountMenu
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.lowerHeader,
    onMouseLeave: () => {
      setShowNav('');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.navigationHeadersContainer
  }, menuHeaderData && menuHeaderData.map((menu, index) => {
    if (!menu.is_active) {
      return;
    }
    var active = showNav === menu.name;
    if (menu.name === "|") {
      return /*#__PURE__*/React.createElement("div", {
        key: menu.name + index,
        className: classes.mainMenuSeparator
      });
    }
    var Component = menu.url_path ? BBLink : Div;
    var text = parse_html(menu.name);
    return /*#__PURE__*/React.createElement(Component, {
      key: text,
      to: resourceUrl('/' + menu.url_path),
      onClick: () => {
        if (menu.url_path) {
          setShowNav("");
        }
      },
      onMouseEnter: () => {
        setShowNav(menu.name);
      },
      className: classes["mainMenuText".concat(menu.classes)] ? "".concat(classes["mainMenuText".concat(menu.classes)]) : classes['mainMenuText'],
      title: getSeoAttributeTitle(text, formatMessage),
      style: active ? {
        textDecoration: 'underline',
        textDecorationThickness: "2px"
      } : {}
    }, text);
  })), activeMenu && /*#__PURE__*/React.createElement(HeaderMenu, {
    left: activeMenuHeader.left,
    right: activeMenuHeader.right,
    actions: activeMenuHeader.actions,
    publicity: activeMenuHeader.publicity,
    setShowNav: setShowNav,
    setInnerNavBar: () => null
  })), /*#__PURE__*/React.createElement(Autocomplete, {
    outWrapperRef: outWrapperRef2
  })));
};
Header.propTypes = {
  classes: shape({
    closed: string,
    logo: string,
    open: string,
    primaryActions: string,
    secondaryActions: string,
    toolbar: string,
    switchers: string,
    switchersContainer: string
  })
};
export default Header;